(ns io.daskul.webapp.nav
  "Pure helpers for role-based navigation rendering.

   Dependency-light (no React/Mantine) so it stays unit-testable on the shared
   :node-test harness.")

(defn visible?
  "Whether a nav `element` (a group or item map) should be shown, given the
   current `flags` map (shape: {flag-name {:enabled bool}}).

   An element declaring `:feature-flags` is shown only when *all* of those
   flags are enabled (AND). Elements without `:feature-flags` are always
   visible. Unknown flags (absent from `flags`) count as disabled.

   This is the single visibility seam for nav — future conditions (e.g. a
   `:when` predicate) extend here."
  [element flags]
  (every? (fn [flag] (boolean (get-in flags [flag :enabled])))
          (:feature-flags element)))
